class SmartMarquee extends HTMLElement {
  connectedCallback() {
    this.classList.add("is-looping");

    const direction = this.getAttribute("direction");
    if (direction === "reverse") {
      this.setAttribute("data-direction", "reverse");
    }

    this._onResize = () => {
      this.classList.add("is-looping");
    };
    window.addEventListener("resize", this._onResize);
  }

  disconnectedCallback() {
    if (this._onResize) {
      window.removeEventListener("resize", this._onResize);
    }
  }
}

customElements.define("smart-marquee", SmartMarquee);
